import React from 'react'

import CheckoutForm from './checkoutForm/checkoutFormContainer'
import EmptyCheckoutForm from './checkoutForm/emptyCheckoutForm'

import styles from './itemDetails.module.css'

const Checkout = ({ licenses, item, location }) => {
  if (!licenses) {
    return <EmptyCheckoutForm item={item} />
  }

  if (licenses.error) {
    return (
      <EmptyCheckoutForm item={item}>
        <div className={styles.errorMessage}>
          Oops, something went wrong and we cannot show the photo price. Please
          try again later.
        </div>
      </EmptyCheckoutForm>
    )
  }

  return <CheckoutForm licenses={licenses} item={item} location={location} />
}

export default Checkout
